import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { PainPoints } from './components/PainPoints';
import { Journey } from './components/Journey';
import { Bands } from './components/Bands';
import { Practice } from './components/Practice';
import { HowItWorks } from './components/HowItWorks';
import { UseCases } from './components/UseCases';
import { Offer } from './components/Offer';
import { Faq } from './components/Faq';
import { ClosingCta } from './components/ClosingCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '1963243531011867';
const PAGE_TITLE = 'KINDERHANDBALL – Mit Plan ins Training | 6 PDF-Bände für 6–12 Jahre';
const PAGE_DESCRIPTION = 'Digitale Praxis-Sammlung für Lehrkräfte und Trainerinnen und Trainer: sechs PDF-Bände mit 360 Seiten Trainingseinheiten für Kinderhandball von 6 bis 12 Jahren.';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  useEffect(() => {
    document.documentElement.lang = 'de';
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
  }, []);
  return <div className="w-full bg-navy-800 font-sans" data-id="element-0" data-mp="2zmwl5831y4h0">
      <Hero data-id="element-1" data-mp="33lwyib2rgewm" />
      <main data-id="element-2" data-mp="33nq55qddiz4m">
        <StatsStrip data-id="element-3" data-mp="33n6yx6x35z6f" />
        <PainPoints data-id="element-4" data-mp="33orjc3pos1qk" />
        <Journey data-id="element-5" data-mp="38lrrqla0dgku" />
        <Bands data-id="element-6" data-mp="38l8eviz7tido" />
        <Practice data-id="element-7" data-mp="38kqafz2efxuo" />
        <HowItWorks data-id="element-8" data-mp="38k6wetfvdtlx" />
        <UseCases data-id="element-9" data-mp="38o4gbha9up6v" />
        <Offer data-id="element-10" data-mp="3dkl42adk71jf" />
        <Faq data-id="element-11" data-mp="3dle4ktlxcut4" />
        <ClosingCta data-id="element-12" data-mp="3dlw542fmdv6u" />
      </main>
      <Footer data-id="element-13" data-mp="3dirv2ofh4589" />
      <StickyCta data-id="element-14" data-mp="3dii694660445" />
    </div>;
}